var map = {
	"./Three": 6585,
	"./Three/": 6585,
	"./Three/Environment": 6167,
	"./Three/Environment.jsx": 6167,
	"./Three/PleaseWait": 5330,
	"./Three/PleaseWait.jsx": 5330,
	"./Three/Render": 1469,
	"./Three/Render.jsx": 1469,
	"./Three/Scene": 1459,
	"./Three/Scene.jsx": 1459,
	"./Three/context/context": 5618,
	"./Three/context/context.jsx": 5618,
	"./Three/index": 6585,
	"./Three/index.jsx": 6585,
	"./Three/model": 6304,
	"./Three/model.jsx": 6304,
	"./Three/package.txt": 1039,
	"./Three/store": 51,
	"./Three/store/": 51,
	"./Three/store/index": 51,
	"./Three/store/index.js": 51,
	"./boxPage": 3431,
	"./boxPage.jsx": 3431,
	"./homePage": 8730,
	"./homePage.jsx": 8730,
	"./img/bgs/letter-bg.png": 8125,
	"./img/bgs/letter-bg.webp": 9350,
	"./img/bgs/love-bg.png": 9533,
	"./img/bgs/love-bg.webp": 6048,
	"./img/bgs/main-bg.png": 9883,
	"./img/bgs/main-bg.webp": 2247,
	"./img/bgs/mobile/main-bg.png": 7882,
	"./img/bgs/mobile/main-bg.webp": 1644,
	"./img/bgs/pyramid-bg.png": 6753,
	"./img/bgs/pyramid-bg.webp": 6193,
	"./img/bgs/pyramid2-bg.webp": 489,
	"./img/bgs/pyramids/pyramid-pink.png": 2725,
	"./img/cioccolatini/brown.png": 8133,
	"./img/cioccolatini/dark.png": 1709,
	"./img/cioccolatini/orange.png": 5352,
	"./img/cioccolatini/pink.png": 8749,
	"./img/cioccolatini/purple.png": 1032,
	"./img/cioccolatini/red.png": 1604,
	"./img/cioccolatini/white-milk.png": 9007,
	"./img/cioccolatini/white.png": 6054,
	"./img/cioccolatini/yellow.png": 1398,
	"./img/content/choose_flavour.svg": 7678,
	"./img/content/cta.svg": 1309,
	"./img/content/img-1.png": 5419,
	"./img/content/img-2.png": 167,
	"./img/content/img-3.png": 4218,
	"./img/content/img-4.png": 2587,
	"./img/content/letter.png": 9270,
	"./img/content/video.png": 1678,
	"./img/icons.zip": 8764,
	"./img/icons/arrow.svg": 4611,
	"./img/icons/arrow2.svg": 5997,
	"./img/icons/choose-icon.svg": 1229,
	"./img/icons/close.svg": 6635,
	"./img/icons/hearts1.png": 3201,
	"./img/icons/hearts1.svg": 816,
	"./img/icons/hearts2.png": 1009,
	"./img/icons/hearts2.svg": 2792,
	"./img/icons/hearts3.png": 8314,
	"./img/icons/hearts3.svg": 9298,
	"./img/icons/hearts4.png": 6037,
	"./img/icons/hearts4.svg": 6028,
	"./img/icons/hearts5.png": 9122,
	"./img/icons/hearts5.svg": 49,
	"./img/icons/hearts6.png": 3637,
	"./img/icons/hearts6.svg": 7526,
	"./img/icons/hearts7.png": 404,
	"./img/icons/shop.svg": 1522,
	"./img/icons_old.zip": 6748,
	"./img/logo-big.svg": 9555,
	"./img/logo.svg": 4688,
	"./productPage": 8218,
	"./productPage.jsx": 8218,
	"./products/globalProducts": 716,
	"./products/globalProducts.json": 716,
	"./shared/cookies/cookiesEn": 9207,
	"./shared/cookies/cookiesEn.jsx": 9207,
	"./shared/cookies/cookiesJp": 5480,
	"./shared/cookies/cookiesJp.jsx": 5480,
	"./shared/cookies/cookiesKr": 1857,
	"./shared/cookies/cookiesKr.jsx": 1857,
	"./shared/footer": 5815,
	"./shared/footer.jsx": 5815,
	"./shared/header": 287,
	"./shared/header.jsx": 287,
	"./shared/shareButtonApi": 6598,
	"./shared/shareButtonApi.jsx": 6598,
	"./shared/shopsList": 2738,
	"./shared/shopsList.jsx": 2738,
	"./shopsPage": 7667,
	"./shopsPage.jsx": 7667,
	"./translate/i18n": 6634,
	"./translate/i18n.js": 6634,
	"./translate/langs/cn": 8864,
	"./translate/langs/cn.json": 8864,
	"./translate/langs/en": 8721,
	"./translate/langs/en.json": 8721,
	"./translate/langs/jp": 5864,
	"./translate/langs/jp.json": 5864,
	"./translate/langs/kr": 1163,
	"./translate/langs/kr.json": 1163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 744;